module.exports = __webpack_public_path__ + "static/media/upgrade.0c390b49.svg";